import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { DropdownModule } from 'primeng/dropdown';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { TagModule } from 'primeng/tag';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TableModule } from 'primeng/table';
import { FileUpload, FileUploadModule } from 'primeng/fileupload';
import { GenericButtonComponent } from "../../../../global/component/generic/generic-button/generic-button.component";
import { AccordionModule } from 'primeng/accordion';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AddExpenseService } from '../../../services/add-expense.service';
import { AutocompleteService } from '../../../services/autocomplete.service';
import { ExpenseItemizationSheetRow } from '../../../models/ExpenseItemizationSheetRow';
import { ExpenseUploadResponse } from '../../../models/ExpenseUploadResponse';
import { ExpenseLineItemModel } from '../../../models/ExpenseLineItemModel';
import { DialogModule } from 'primeng/dialog';
import { MessageModule } from 'primeng/message';
import { EntityType } from '../../../models/ConstantsAndEnums';
import { catchError, debounceTime, distinctUntilChanged } from 'rxjs';
import { AddUpdateVendorService } from '../../../services/add-update-vendor.service';
import { autocompleteSelectionValidator } from '../../../validators/non-async-validators';
import { restrictToTwoDecimals } from '../../../../global/util/util';

@Component({
  selector: 'expense-add-itemization',
  templateUrl: './expense-add-itemization.component.html',
  styleUrls: ['./expense-add-itemization.component.scss'],
  imports: [ButtonModule, CardModule, AutoCompleteModule, DropdownModule, CommonModule, CalendarModule, InputTextModule, InputTextareaModule, TagModule, MessageModule,
    SelectButtonModule, TableModule, FileUploadModule, GenericButtonComponent, AccordionModule, DialogModule, ReactiveFormsModule],
  standalone: true,
  providers: [
    ConfirmationService,
    MessageService,
    AddExpenseService,
    AutocompleteService,
    AddUpdateVendorService
  ],
})
export class ExpenseAddItemizationComponent implements OnInit {
  @Input() campaignId!: number;
  @Input() expenseId!: number;
  @Input() expenseDetails: any;
  @Input() confirmAction!: (
    message: string,
    acceptCallback: () => void,
    rejectCallback?: () => void
  ) => void;
  @Output() prevCallback = new EventEmitter<void>();
  @Output() nextCallback = new EventEmitter<void>();
  @Output() errorEvent = new EventEmitter<string>();
  activeTabIndices: number[] = [];
  isEdit = false;
  itemizationDialog = false;
  stageditemizations: ExpenseItemizationSheetRow[] = [];
  itemizations: ExpenseLineItemModel[] = [];
  uploadResponse: ExpenseUploadResponse | null = null;;
  @ViewChild('fileUploader') fileUploader!: FileUpload;
  expenseitemizationForm!: FormGroup;
  eventSuggestions: any = [];
  accountSuggestions: any = [];
  vendorSuggestions: any = [];
  showWarning = false;

  constructor(private fb: FormBuilder, private addExpenseService: AddExpenseService, private autoCompleteService: AutocompleteService, private vendorService: AddUpdateVendorService, private confirmationService: ConfirmationService) {

  }

  ngOnInit() {
    this.initForm();
    this.addExpenseService.getExpenselineitems(this.expenseId, true).subscribe({
      next: (data) => {
        this.itemizations = data;
        if (this.itemizations.length > 0)
          this.activeTabIndices = [1];
        else
          this.activeTabIndices = [0];

        this.CheckForWarningtoDisplay();
      },
      error: () => {
        this.errorEvent.emit('Failed to get new Current Itemization Details');
      }
    });
  }
  CheckForWarningtoDisplay() {
    if (this.totalAmount > parseFloat(this.expenseDetails["requestedAmount"])) {
      this.showWarning = true;
    }
    else {
      this.showWarning = false;
    }
  }

  initForm() {
    this.expenseitemizationForm = this.fb.group({
      requestId: [''],
      lineItemId: [''],
      vendor: ['', [Validators.required, autocompleteSelectionValidator(() => this.vendorSuggestions)]],
      lineItem_VendorId: [],
      paymentDate: ['', Validators.required],
      lineNumber: [''],
      lineItem_CampaignId: [''],
      lineItem_RequestedAmount: ['', Validators.required],
      event: [''],
      eventId: [''],
      account: ['', Validators.required],
      glAccountId: ['', Validators.required],
      isMemo: [true],
      description: ['']
    });
  }
  onFileUpload(event: any) {
    const files: File[] = event.files;
    console.debug('Selected files:', files);
    if (!files || files.length === 0) {
      this.errorEvent.emit('Please select files to upload.');
      return;
    }
    else if (files.length > 1) {
      this.errorEvent.emit('Please select only one file');
      return;
    }
    const formData = new FormData();
    files.forEach(file => {
      formData.append('files', file, file.name);
      formData.append('CampaignId', this.campaignId.toString());
      formData.append('ExpenseRequestId', this.expenseId.toString());
    });
    this.addExpenseService.uploadItemization(formData).subscribe({
      next: (stagedData) => {
        this.uploadResponse = stagedData;
        this.stageditemizations = stagedData.data;
      },
      error: () => {
        this.errorEvent.emit('Upload File Failed!');
      }
    });
  }

  editLineItemDialog(item: ExpenseLineItemModel) {
    this.isEdit = true;
    this.expenseitemizationForm.get('requestId')?.setValue(this.expenseId);
    this.expenseitemizationForm.get('lineItem_CampaignId')?.setValue(this.campaignId);
    this.expenseitemizationForm.get('lineItemId')?.setValue(item.lineItemID);
    this.expenseitemizationForm.get('lineNumber')?.setValue(item.lineNumber);
    this.expenseitemizationForm.get('vendor')?.setValue(item.lineItem_VendorName + ` (${item.lineItem_VendorAddress})`);
    this.expenseitemizationForm.get('lineItem_VendorId')?.setValue(item.lineItem_VendorId.trim());
    this.expenseitemizationForm.get('paymentDate')?.setValue(new Date(item.paymentDate));
    this.expenseitemizationForm.get('lineItem_RequestedAmount')?.setValue(item.lineItem_RequestedAmount);
    this.expenseitemizationForm.get('event')?.setValue(item.eventDescription);
    this.expenseitemizationForm.get('account')?.setValue(item.glAccountId != null && item.glAccountId > 0 ? item.glAccountDisplayText : '');
    this.expenseitemizationForm.get('glAccountId')?.setValue(item.glAccountId);
    this.expenseitemizationForm.get('description')?.setValue(item.description);
    this.itemizationDialog = true;
    this.CheckForWarningtoDisplay();
  }

  deleteLineItem(request: ExpenseLineItemModel) {
    this.confirmAction?.(`Are you sure you want to delete ${request.lineItemID}?`,
      () => {
        this.addExpenseService.deleteExpenselineitem(request.lineItemID).subscribe({
          next: () => {
            this.addExpenseService.getExpenselineitems(this.expenseId, true).subscribe({
              next: (data) => {
                this.itemizations = data;
                this.CheckForWarningtoDisplay();
              },
              error: () => {
                this.errorEvent.emit('Failed to get itemizations');
              }
            });
          },
          error: () => {
            this.errorEvent.emit('Failed to delete all the itemizations');
          }
        })
      },
      () => {  //Reject Functionality
      }
    );
  }
  onErrorFile(uploadResponse: ExpenseUploadResponse, event: any) {
    event.preventDefault();
    this.addExpenseService.getErrorFile(uploadResponse.errroFile).subscribe({
      next: (blob) => {
        const a = document.createElement('a');
        const url = URL.createObjectURL(blob);
        a.href = url;
        a.download = uploadResponse.errroFile;
        a.click();
        URL.revokeObjectURL(url);
      },
      error: (err) => {
        this.errorEvent.emit('Failed to get Error Itemization Template!');
      },
    });
  }
  onWarningFile(uploadResponse: ExpenseUploadResponse, event: any) {
    event.preventDefault();
    this.addExpenseService.getWarningFile(uploadResponse.warningFile).subscribe({
      next: (blob) => {
        const a = document.createElement('a');
        const url = URL.createObjectURL(blob);
        a.href = url;
        a.download = uploadResponse.warningFile;
        a.click();
        URL.revokeObjectURL(url);
      },
      error: (err) => {
        this.errorEvent.emit('Failed to get Error Itemization Template!');
      },
    });
  }

  onClear() {
    this.uploadResponse = null;
    this.stageditemizations = [];
    this.fileUploader.clear();
  }
  onSaveItemization() {
    if (this.uploadResponse) {
      this.addExpenseService.saveItemization(this.expenseId, this.uploadResponse.data).subscribe({
        next: (success) => {
          if (success === true) {
            this.addExpenseService.getExpenselineitems(this.expenseId, true).subscribe({
              next: (data) => {
                this.itemizations = data;
                this.onClear();
                this.fileUploader.clear();
                if (this.itemizations.length > 0)
                  this.activeTabIndices = [1];
                this.CheckForWarningtoDisplay();
              },
              error: () => {
                this.errorEvent.emit('Failed to get new Current Itemization Details');
              }
            });

          }
        },
        error: () => {
          this.errorEvent.emit('Save Itemization Failed!');
        }
      });
    }
  }

  get totalAmount(): number {
    return this.itemizations.reduce((sum, row) => sum + (row.lineItem_RequestedAmount || 0), 0) || 0;
  }

  onAddItemization() {
    this.isEdit = false;
    this.expenseitemizationForm.reset();
    this.expenseitemizationForm.get('requestId')?.setValue(this.expenseId);
    this.expenseitemizationForm.get('lineItem_CampaignId')?.setValue(this.campaignId);
    this.expenseitemizationForm.get('lineItemId')?.setValue('0');
    this.expenseitemizationForm.get('lineNumber')?.setValue('1');
    this.expenseitemizationForm.get('isMemo')?.setValue(true);
    this.itemizationDialog = true;
    this.CheckForWarningtoDisplay();
  }

  onDeleteAll() {
    this.confirmAction?.('Are you sure you want to delete all the itemizations?',
      () => {
        this.addExpenseService.deleteAllExpenselineitem(this.expenseId).subscribe({
          next: () => {
            this.addExpenseService.getExpenselineitems(this.expenseId, true).subscribe({
              next: (data) => {
                this.itemizations = data;
                this.CheckForWarningtoDisplay();
              },
              error: () => {
                this.errorEvent.emit('Failed to get itemizations');
              }
            });
          },
          error: () => {
            this.errorEvent.emit('Failed to delete all the itemizations');
          }
        })
      },
      () => {  //Reject Functionality
      }
    );
  }

  onVendorSelect(vendor: any) {
    const vendorId = vendor.value.value;
    this.expenseitemizationForm.get('lineItem_VendorId')?.setValue(vendorId);
  }

  searchVendor(query: string): void {
    if (!query) {
      this.vendorSuggestions = [];
      return;
    }
    this.autoCompleteService.getAutoCompleteResults(query, EntityType.Vendors, this.campaignId).pipe(
      debounceTime(300),
      distinctUntilChanged(),
      catchError(() => [])
    ).subscribe((results) => {
      this.vendorSuggestions = this.mapToLabelValue(results);
      this.expenseitemizationForm.get('lineItem_VendorId')?.updateValueAndValidity();
    });
  }

  onNext() {
    // Perform any validation or data processing here
    this.nextCallback.emit();
  }
  downloadTemplate(event: MouseEvent) {
    event.preventDefault();
    this.addExpenseService.getExpenseItemizationTemplate().subscribe({
      next: (blob) => {
        const a = document.createElement('a');
        const url = URL.createObjectURL(blob);
        a.href = url;
        a.download = "Expense Itemization Template.xlsx";
        a.click();
        URL.revokeObjectURL(url);
      },
      error: (err) => {
        this.errorEvent.emit('Failed to get Itemization Template!');
      },
    });
  }

  saveItemization(isEdit: boolean) {
    if (isEdit) {
      if (this.expenseitemizationForm.valid) {
        this.addExpenseService.updateExpenselineitem(this.expenseitemizationForm.value).subscribe({
          next: () => {
            this.addExpenseService.getExpenselineitems(this.expenseId, true).subscribe({
              next: (data) => {
                this.itemizations = data;
                this.itemizationDialog = false;
                this.CheckForWarningtoDisplay();
              },
              error: () => {
                this.errorEvent.emit('Failed to get new LineItem Details');
              }
            });
          },
          error: () => {
            this.errorEvent.emit('Failed to save LineItem Details');
          }
        });
      } else {
        this.markAllAsTouched(this.expenseitemizationForm);
      }
    }
    else {
      if (this.expenseitemizationForm.valid) {
        this.addExpenseService.saveExpenselineitem(this.expenseitemizationForm.value).subscribe({
          next: () => {
            this.addExpenseService.getExpenselineitems(this.expenseId, true).subscribe({
              next: (data) => {
                this.itemizations = data;
                this.itemizationDialog = false;
                this.CheckForWarningtoDisplay();
              },
              error: () => {
                this.errorEvent.emit('Failed to get new LineItem Details');
              }
            });
          },
          error: () => {
            this.errorEvent.emit('Failed to save LineItem Details');
          }
        });
      } else {
        this.markAllAsTouched(this.expenseitemizationForm);
      }
    }
  }
  markAllAsTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      formGroup.get(field)?.markAsTouched();
    });
  }

  onCancelItemization() {
    this.itemizationDialog = false;
  }

  searchEvent(query: string): void {
    if (!query) {
      this.eventSuggestions = [];
      return;
    }
    this.autoCompleteService.getAutoCompleteResults(query, EntityType.Events, this.campaignId).pipe(
      debounceTime(300),
      distinctUntilChanged(),
      catchError(() => [])
    ).subscribe((results) => {
      this.eventSuggestions = this.mapToLabelValue(results);
      this.expenseitemizationForm.get('eventId')?.updateValueAndValidity();
    });
  }
  private mapToLabelValue(items: any[]): { label: string, value: string }[] {
    return items?.map((item: any) => ({ label: item.text, value: item.value })) || [];
  }
  onEventSelect(event: any) {
    const eventId = event.value.value;
    this.expenseitemizationForm.get('eventId')?.setValue(eventId);
  }

  searchAccount(query: string): void {
    if (!query) {
      this.accountSuggestions = [];
      return;
    }
    this.autoCompleteService.getAutoCompleteResults(query, EntityType.GLAccounts, this.campaignId).pipe(
      debounceTime(300),
      distinctUntilChanged(),
      catchError(() => [])
    ).subscribe((results) => {
      this.accountSuggestions = this.mapToLabelValue(results);
      this.expenseitemizationForm.get('glAccountId')?.updateValueAndValidity();
    });
  }

  onAccountSelect(account: any) {
    const glAccountId = account.value.value;
    this.expenseitemizationForm.get('glAccountId')?.setValue(glAccountId);
  }
  onSaveExpense(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      resolve(true);
    });
  }

    onAmountInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = restrictToTwoDecimals(input.value);
    this.expenseitemizationForm.get('lineItem_RequestedAmount')?.setValue(input.value, { emitEvent: false });
  }
}
